/* eslint-disable react/jsx-props-no-spreading */

import TemperatureInfo from './TemperatureInfo'

const TemperatureInfoContainer = (props) => {
    return (
        <TemperatureInfo {...props} />
    )
}

export default TemperatureInfoContainer
